
import { Component, Emit, Vue } from 'vue-property-decorator';
import CheckBox from '@/components/utils/CheckBox.vue';
import Popup from '@/components/utils/Popup.vue';
import Alert from '@/components/utils/Alert.vue';
import { EventEmitter } from 'events';
@Component({ components: { CheckBox, Popup, Alert } })
export default class ZawatiralOperatinalLogin extends Vue {
  agreed = false;
  popupShown = false;
  email = '';
  emailFormatError = '';
  /**
   * 'shake'イベントを受け取った際にアラートを横揺れさせるアニメーションをトリガーします。
   */
  alertEventEmitter = new EventEmitter();
  @Emit('onLoginWithProvider') onLoginWithProvider(id: string) {}
  @Emit('onLoginAsGuest') onLoginAsGuest(email: string) {}

  onCheckBoxChange() {
    this.agreed = !this.agreed;
    if (!this.agreed) {
      this.emailFormatError = '';
      this.email = '';
    }
  }

  onGuestLogin(event: SubmitEvent) {
    event.preventDefault();
    const result = this.validateEmailFormat(this.email);
    if (!result.isValid) {
      if (this.emailFormatError === result.errorMsg) {
        this.alertEventEmitter.emit('shake');
      }
      this.emailFormatError = result.errorMsg;
      return;
    }
    this.onLoginAsGuest(this.email);
    this.emailFormatError = '';
    this.email = '';
  }

  private validateEmailFormat(email: string) {
    type ValidationResult = {
      isValid: boolean;
      errorMsg: string;
    };
    if (email === '') {
      const result: ValidationResult = {
        isValid: false,
        errorMsg: 'メールアドレスを入力してください',
      };
      return result;
    }
    const emailRegex = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
    if (!emailRegex.test(email)) {
      const result: ValidationResult = {
        isValid: false,
        errorMsg: 'メールアドレスの形式が正しくありません',
      };
      return result;
    }
    const result: ValidationResult = {
      isValid: true,
      errorMsg: '',
    };
    return result;
  }
}
